module.exports = __webpack_public_path__ + "img/ship_1.5537f493.webp";